import { render, staticRenderFns } from "./ProductPromotionList.vue?vue&type=template&id=65300112&"
import script from "./ProductPromotionList.vue?vue&type=script&lang=js&"
export * from "./ProductPromotionList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports